import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = () => ({
  display: 'flex',
  position: 'relative',
});

const SettingsWrapper = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

SettingsWrapper.propTypes = {
  children: PropTypes.node,
};

export default React.memo(SettingsWrapper);
